const FB_ORDERS_SETTINGS = {
  beepOnNewOrder: false,
  beepWhileOrderPending: false,
  fillOrdersHere: false,
  popupOnNewOrder: false,
};

const FOOD_ORDER = [];

export { FB_ORDERS_SETTINGS, FOOD_ORDER };
